import BookingCoveringViewModel from './bookingCoveringViewModel'

export default class PendingBookingSummaryDetailsViewModel {
  constructor(params) {
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.earliestDate = params.earliestDate
    this.latestDate = params.latestDate
    this.areDatesConsecutive = params.areDatesConsecutive
    this.covering = params.covering
      ? new BookingCoveringViewModel(params.covering)
      : null
  }
}
